<template>
    <div class="template-viewer-wrapper" :style="wrapperStyle">
        <div class="template-viewer" v-if="template && qrConfig"
             :style="{
                 width: template.width + 'px',
                 height: template.height + 'px',
                 borderRadius: template.borderRadius,
                 backgroundColor: template.backgroundColor,
                 transform: 'scale(' + scale + ')'
             }">
            <div v-for="(component, i) in template.components as any[]" :key="i"
                 class="page-component"
                 :style="{
                     left: component.x + 'px',
                     top: component.y + 'px',
                     width: component.width || component.size + 'px',
                     height: component.height || component.size + 'px'
                 }">
                <text-component-viewer v-if="component.type === 'TextComponent'" :item="component" />
                <image-component-viewer v-if="component.type === 'ImageComponent'" :item="component" />
                <qr-printer v-if="component.type === 'QrCodeComponent'" :identifier="qrConfig.identifier" class="qr-fill" />
                <qr-field-component-viewer v-if="component.type === 'QrFieldComponent'" :item="component" :qrConfig="qrConfig" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { PrintTemplateClient, QrConfigClient } from '@/services/Services';

@Options({})
export default class TemplateViewer extends Vue {

    @Prop() templateIdentifier: string;
    @Prop() qrConfigIdentifier: string;

    template: OM.PrintTemplate = null;
    qrConfig: OM.QrConfig = null;
    availableWidth = 0;
    resizeObserver: ResizeObserver = null;

    created() {
        this.load();
    }

    mounted() {
        this.resizeObserver = new ResizeObserver(entries => {
            this.availableWidth = entries[0].contentRect.width;
        });
        this.resizeObserver.observe(this.$el.parentElement);
    }

    beforeUnmount() {
        this.resizeObserver?.disconnect();
    }

    @Watch('templateIdentifier')
    @Watch('qrConfigIdentifier')
    load() {
        if (!this.templateIdentifier || !this.qrConfigIdentifier) return;

        Promise.all([
            PrintTemplateClient.getById(this.templateIdentifier),
            QrConfigClient.getById(this.qrConfigIdentifier)
        ])
        .then(([template, qrConfig]) => {
            this.template = template;
            this.qrConfig = qrConfig;
        });
    }

    // Scala il template per farlo entrare nel contenitore disponibile, senza mai ingrandirlo oltre la dimensione reale
    get scale(): number {
        if (!this.template?.width || !this.availableWidth) return 1;
        return Math.min(1, this.availableWidth / this.template.width);
    }

    get wrapperStyle(): Record<string, string> {
        if (!this.template) return {};
        return {
            width: (this.template.width * this.scale) + 'px',
            height: (this.template.height * this.scale) + 'px'
        };
    }

}
</script>

<style scoped>
.template-viewer {
    position: relative;
    transform-origin: top left;
}

.page-component {
    position: absolute;
}

.qr-fill :deep(img) {
    width: 100%;
    height: 100%;
}
</style>
